var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var Ticket_Type_Code;
(function (Ticket_Type_Code) {
    Ticket_Type_Code["Appointment"] = "appointment";
    Ticket_Type_Code["BenefitsQuestion"] = "benefits_question";
    Ticket_Type_Code["BillingAdvocacy"] = "billing_advocacy";
    Ticket_Type_Code["BillingReview"] = "billing_review";
    Ticket_Type_Code["CarrierProcessing"] = "carrier_processing";
    Ticket_Type_Code["ClaimRejection"] = "claim_rejection";
    Ticket_Type_Code["ClaimReversal"] = "claim_reversal";
    Ticket_Type_Code["ClinicalAssessment"] = "clinical_assessment";
    Ticket_Type_Code["ClinicalFollowUp"] = "clinical_follow_up";
    Ticket_Type_Code["Consult"] = "consult";
    Ticket_Type_Code["CpEligibilityRequest"] = "cp_eligibility_request";
    Ticket_Type_Code["CpExistingNavBenefitEducationRequest"] = "cp_existing_nav_benefit_education_request";
    Ticket_Type_Code["CpExistingNavBillingAdvocacyRequest"] = "cp_existing_nav_billing_advocacy_request";
    Ticket_Type_Code["CpExistingNavCareRequest"] = "cp_existing_nav_care_request";
    Ticket_Type_Code["CpExistingNavClinicalSupportRequest"] = "cp_existing_nav_clinical_support_request";
    Ticket_Type_Code["CpExistingNavMemberServicesRequest"] = "cp_existing_nav_member_services_request";
    Ticket_Type_Code["CpGeneralInquiry"] = "cp_general_inquiry";
    Ticket_Type_Code["CpMailOrderRequest"] = "cp_mail_order_request";
    Ticket_Type_Code["CpNavBenefitEducationRequest"] = "cp_nav_benefit_education_request";
    Ticket_Type_Code["CpNavBillingAdvocacyRequest"] = "cp_nav_billing_advocacy_request";
    Ticket_Type_Code["CpNavCareRequest"] = "cp_nav_care_request";
    Ticket_Type_Code["CpNavClinicalSupportRequest"] = "cp_nav_clinical_support_request";
    Ticket_Type_Code["CpNavGeneralInquiry"] = "cp_nav_general_inquiry";
    Ticket_Type_Code["CpNavMemberServicesRequest"] = "cp_nav_member_services_request";
    Ticket_Type_Code["CpNavOnsiteRequest"] = "cp_nav_onsite_request";
    Ticket_Type_Code["CpNavOverviewDemoRequest"] = "cp_nav_overview_demo_request";
    Ticket_Type_Code["CpNavReportRequest"] = "cp_nav_report_request";
    Ticket_Type_Code["CpNewMemberRequest"] = "cp_new_member_request";
    Ticket_Type_Code["CpOverrideRequest"] = "cp_override_request";
    Ticket_Type_Code["CpPharmacyIdRequest"] = "cp_pharmacy_id_request";
    Ticket_Type_Code["CpPriorAuthRequest"] = "cp_prior_auth_request";
    Ticket_Type_Code["CpSpecialtyRequest"] = "cp_specialty_request";
    Ticket_Type_Code["Eligibility"] = "eligibility";
    Ticket_Type_Code["FindCare"] = "find_care";
    Ticket_Type_Code["FollowUp"] = "follow_up";
    Ticket_Type_Code["GeneralInquiry"] = "general_inquiry";
    Ticket_Type_Code["IdCard"] = "id_card";
    Ticket_Type_Code["MailOrder"] = "mail_order";
    Ticket_Type_Code["MedicalBenefitInquiry"] = "medical_benefit_inquiry";
    Ticket_Type_Code["MedicalNavigation"] = "medical_navigation";
    Ticket_Type_Code["MissedCall"] = "missed_call";
    Ticket_Type_Code["MobileAppSupport"] = "mobile_app_support";
    Ticket_Type_Code["Other"] = "other";
    Ticket_Type_Code["OutOfNetworkSubmission"] = "out_of_network_submission";
    Ticket_Type_Code["OutboundEngagement"] = "outbound_engagement";
    Ticket_Type_Code["Override"] = "override";
    Ticket_Type_Code["PbmAdherenceRefillReminder"] = "pbm_adherence_refill_reminder";
    Ticket_Type_Code["PbmAppSupport"] = "pbm_app_support";
    Ticket_Type_Code["PbmBenefitChange"] = "pbm_benefit_change";
    Ticket_Type_Code["PbmCboBenefitQuestion"] = "pbm_cbo_benefit_question";
    Ticket_Type_Code["PbmCboDrugListUpdate"] = "pbm_cbo_drug_list_update";
    Ticket_Type_Code["PbmCcdpComplete"] = "pbm_ccdp_complete";
    Ticket_Type_Code["PbmCcdpEligible"] = "pbm_ccdp_eligible";
    Ticket_Type_Code["PbmCcdpOutreach_1"] = "pbm_ccdp_outreach_1";
    Ticket_Type_Code["PbmCcdpOutreach_2"] = "pbm_ccdp_outreach_2";
    Ticket_Type_Code["PbmCcdpOutreach_3"] = "pbm_ccdp_outreach_3";
    Ticket_Type_Code["PbmCcdpQ1CheckIn"] = "pbm_ccdp_q1_check_in";
    Ticket_Type_Code["PbmCcdpQ2CheckIn"] = "pbm_ccdp_q2_check_in";
    Ticket_Type_Code["PbmCcdpQ3CheckIn"] = "pbm_ccdp_q3_check_in";
    Ticket_Type_Code["PbmCcdpQ4CheckIn"] = "pbm_ccdp_q4_check_in";
    Ticket_Type_Code["PbmCcoPriorAuthorizationStatus"] = "pbm_cco_prior_authorization_status";
    Ticket_Type_Code["PbmCcwmpComplete"] = "pbm_ccwmp_complete";
    Ticket_Type_Code["PbmCcwmpEligible"] = "pbm_ccwmp_eligible";
    Ticket_Type_Code["PbmCcwmpQ1CheckIn"] = "pbm_ccwmp_q1_check_in";
    Ticket_Type_Code["PbmCcwmpQ2CheckIn"] = "pbm_ccwmp_q2_check_in";
    Ticket_Type_Code["PbmCcwmpQ3CheckIn"] = "pbm_ccwmp_q3_check_in";
    Ticket_Type_Code["PbmCcwmpQ4CheckIn"] = "pbm_ccwmp_q4_check_in";
    Ticket_Type_Code["PbmCostPlusConversion"] = "pbm_cost_plus_conversion";
    Ticket_Type_Code["PbmDoAccumulatorIssue"] = "pbm_do_accumulator_issue";
    Ticket_Type_Code["PbmDoClaimFileProcessing"] = "pbm_do_claim_file_processing";
    Ticket_Type_Code["PbmDoEligibilityInquiry"] = "pbm_do_eligibility_inquiry";
    Ticket_Type_Code["PbmDoGroupTerming"] = "pbm_do_group_terming";
    Ticket_Type_Code["PbmDoImpactReport"] = "pbm_do_impact_report";
    Ticket_Type_Code["PbmDoNewImplementation"] = "pbm_do_new_implementation";
    Ticket_Type_Code["PbmDoPchAccumulatorChange"] = "pbm_do_pch_accumulator_change";
    Ticket_Type_Code["PbmDoPchFertilityMaximum"] = "pbm_do_pch_fertility_maximum";
    Ticket_Type_Code["PbmDoPchGroupNumberChange"] = "pbm_do_pch_group_number_change";
    Ticket_Type_Code["PbmDoPchOther"] = "pbm_do_pch_other";
    Ticket_Type_Code["PbmDoVendorSetup"] = "pbm_do_vendor_setup";
    Ticket_Type_Code["PbmDrugInteraction"] = "pbm_drug_interaction";
    Ticket_Type_Code["PbmFollowUp"] = "pbm_follow_up";
    Ticket_Type_Code["PbmGapInTherapy"] = "pbm_gap_in_therapy";
    Ticket_Type_Code["PbmIdCardRequest"] = "pbm_id_card_request";
    Ticket_Type_Code["PbmIntake"] = "pbm_intake";
    Ticket_Type_Code["PbmMailOrderTransfer"] = "pbm_mail_order_transfer";
    Ticket_Type_Code["PbmMemberServices"] = "pbm_member_services";
    Ticket_Type_Code["PbmNonSpecialtyMeds"] = "pbm_non_specialty_meds";
    Ticket_Type_Code["PbmOnboardingSupport"] = "pbm_onboarding_support";
    Ticket_Type_Code["PbmOther"] = "pbm_other";
    Ticket_Type_Code["PbmOtherEmail"] = "pbm_other_email";
    Ticket_Type_Code["PbmOutcomesMtm"] = "pbm_outcomes_mtm";
    Ticket_Type_Code["PbmPatientEducation"] = "pbm_patient_education";
    Ticket_Type_Code["PbmPharmacyFollowUp"] = "pbm_pharmacy_follow_up";
    Ticket_Type_Code["PbmPharmacyNav"] = "pbm_pharmacy_nav";
    Ticket_Type_Code["PbmPriorAuthorizationDenial"] = "pbm_prior_authorization_denial";
    Ticket_Type_Code["PbmProactiveDrugSearch"] = "pbm_proactive_drug_search";
    Ticket_Type_Code["PbmProactiveOutreach"] = "pbm_proactive_outreach";
    Ticket_Type_Code["PbmProviderFollowUp"] = "pbm_provider_follow_up";
    Ticket_Type_Code["PbmRxPricing"] = "pbm_rx_pricing";
    Ticket_Type_Code["PbmRxSaver"] = "pbm_rx_saver";
    Ticket_Type_Code["PbmSpecialtyMedication"] = "pbm_specialty_medication";
    Ticket_Type_Code["PbmSuboptimalDrugDosage"] = "pbm_suboptimal_drug_dosage";
    Ticket_Type_Code["PbmTips"] = "pbm_tips";
    Ticket_Type_Code["PbmUm"] = "pbm_um";
    Ticket_Type_Code["PbmVoicemail"] = "pbm_voicemail";
    Ticket_Type_Code["PharmacyBenefitInquiry"] = "pharmacy_benefit_inquiry";
    Ticket_Type_Code["PharmacyNetwork"] = "pharmacy_network";
    Ticket_Type_Code["PlanSelection"] = "plan_selection";
    Ticket_Type_Code["Pricing"] = "pricing";
    Ticket_Type_Code["PriorAuthorization"] = "prior_authorization";
    Ticket_Type_Code["SeldonBeattieWellness"] = "seldon_beattie_wellness";
    Ticket_Type_Code["SpecialtyCostPlusConversion"] = "specialty_cost_plus_conversion";
    Ticket_Type_Code["TechSupport"] = "tech_support";
    Ticket_Type_Code["TelemedicineScheduling"] = "telemedicine_scheduling";
    Ticket_Type_Code["Triage"] = "triage";
    Ticket_Type_Code["Wellness"] = "wellness";
})(Ticket_Type_Code || (Ticket_Type_Code = {}));
export var BILLING_ADVOCACY_TYPES = [
    Ticket_Type_Code.BillingAdvocacy,
    Ticket_Type_Code.CarrierProcessing,
    Ticket_Type_Code.OutOfNetworkSubmission,
    Ticket_Type_Code.BillingReview
];
export var PBM_CONTACT_CENTER_COMMON_TYPES = [
    Ticket_Type_Code.Eligibility,
    Ticket_Type_Code.PharmacyBenefitInquiry,
    Ticket_Type_Code.Pricing,
    Ticket_Type_Code.MailOrder,
    Ticket_Type_Code.ClaimRejection,
    Ticket_Type_Code.Consult,
    Ticket_Type_Code.PharmacyNetwork,
    Ticket_Type_Code.MedicalBenefitInquiry,
    Ticket_Type_Code.MobileAppSupport,
    Ticket_Type_Code.IdCard,
    Ticket_Type_Code.ClaimReversal
];
export var PBM_CONTACT_CENTER_TYPES = __spreadArray(__spreadArray([], PBM_CONTACT_CENTER_COMMON_TYPES, true), [
    Ticket_Type_Code.PriorAuthorization,
    Ticket_Type_Code.Override
], false);
export var PBM_CCDP_TYPES = [
    Ticket_Type_Code.PbmCcdpEligible,
    Ticket_Type_Code.PbmCcdpComplete,
    Ticket_Type_Code.PbmCcdpOutreach_1,
    Ticket_Type_Code.PbmCcdpOutreach_2,
    Ticket_Type_Code.PbmCcdpOutreach_3
];
export var PBM_CCWMP_TYPES = [
    Ticket_Type_Code.PbmCcwmpEligible,
    Ticket_Type_Code.PbmCcwmpComplete
];
export var PBM_FOLLOW_UP_TYPES = [
    Ticket_Type_Code.FollowUp,
    Ticket_Type_Code.PbmCcdpQ1CheckIn,
    Ticket_Type_Code.PbmCcdpQ2CheckIn,
    Ticket_Type_Code.PbmCcdpQ3CheckIn,
    Ticket_Type_Code.PbmCcdpQ4CheckIn,
    Ticket_Type_Code.PbmCcwmpQ1CheckIn,
    Ticket_Type_Code.PbmCcwmpQ2CheckIn,
    Ticket_Type_Code.PbmCcwmpQ3CheckIn,
    Ticket_Type_Code.PbmCcwmpQ4CheckIn
];
export var PBM_FINANCIAL_TYPES = [
    Ticket_Type_Code.PbmRxSaver,
    Ticket_Type_Code.PbmRxPricing,
    Ticket_Type_Code.PbmCostPlusConversion,
    Ticket_Type_Code.PbmProactiveOutreach
];
export var PBM_DO_TYPES = [
    Ticket_Type_Code.PbmDoPchAccumulatorChange,
    Ticket_Type_Code.PbmDoPchFertilityMaximum,
    Ticket_Type_Code.PbmDoPchGroupNumberChange,
    Ticket_Type_Code.PbmDoPchOther,
    Ticket_Type_Code.PbmDoAccumulatorIssue,
    Ticket_Type_Code.PbmDoVendorSetup,
    Ticket_Type_Code.PbmDoNewImplementation,
    Ticket_Type_Code.PbmDoGroupTerming,
    Ticket_Type_Code.PbmDoImpactReport,
    Ticket_Type_Code.PbmDoClaimFileProcessing,
    Ticket_Type_Code.PbmDoEligibilityInquiry
];
export var CLIENT_PORTAL_TYPES = [
    Ticket_Type_Code.CpEligibilityRequest,
    Ticket_Type_Code.CpPharmacyIdRequest,
    Ticket_Type_Code.CpGeneralInquiry,
    Ticket_Type_Code.CpMailOrderRequest,
    Ticket_Type_Code.CpOverrideRequest,
    Ticket_Type_Code.CpPriorAuthRequest,
    Ticket_Type_Code.CpSpecialtyRequest,
    Ticket_Type_Code.CpNewMemberRequest,
    Ticket_Type_Code.CpNavGeneralInquiry,
    Ticket_Type_Code.CpNavOnsiteRequest,
    Ticket_Type_Code.CpNavReportRequest,
    Ticket_Type_Code.CpNavOverviewDemoRequest,
    Ticket_Type_Code.CpNavBenefitEducationRequest,
    Ticket_Type_Code.CpNavCareRequest,
    Ticket_Type_Code.CpNavClinicalSupportRequest,
    Ticket_Type_Code.CpNavMemberServicesRequest,
    Ticket_Type_Code.CpNavBillingAdvocacyRequest,
    Ticket_Type_Code.CpExistingNavBenefitEducationRequest,
    Ticket_Type_Code.CpExistingNavCareRequest,
    Ticket_Type_Code.CpExistingNavClinicalSupportRequest,
    Ticket_Type_Code.CpExistingNavMemberServicesRequest,
    Ticket_Type_Code.CpExistingNavBillingAdvocacyRequest
];
export var REQUEST_TICKET_TYPES = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
    Ticket_Type_Code.Appointment,
    Ticket_Type_Code.FindCare,
    Ticket_Type_Code.Wellness,
    Ticket_Type_Code.SeldonBeattieWellness,
    Ticket_Type_Code.MedicalNavigation
], BILLING_ADVOCACY_TYPES, true), PBM_CCDP_TYPES, true), PBM_FINANCIAL_TYPES, true), PBM_CONTACT_CENTER_TYPES, true), PBM_DO_TYPES, true), PBM_CCWMP_TYPES, true), [
    Ticket_Type_Code.PbmCboBenefitQuestion,
    Ticket_Type_Code.PbmCcoPriorAuthorizationStatus,
    Ticket_Type_Code.CpNavOnsiteRequest,
    Ticket_Type_Code.CpNavReportRequest,
    Ticket_Type_Code.CpNavOverviewDemoRequest,
    Ticket_Type_Code.PbmCboDrugListUpdate
], false);
// Subjects that cannot be changed once set. Distinct from PROHIBITED_TICKET_TYPES,
// which lists subjects a ticket cannot be changed *to*.
export var SUBJECT_LOCKED_TICKET_TYPES = __spreadArray([
    Ticket_Type_Code.FollowUp
], CLIENT_PORTAL_TYPES, true);
export var PROHIBITED_TICKET_TYPES = __spreadArray([
    Ticket_Type_Code.FollowUp,
    Ticket_Type_Code.PbmFollowUp,
    Ticket_Type_Code.ClinicalFollowUp,
    Ticket_Type_Code.Triage,
    Ticket_Type_Code.PbmMailOrderTransfer,
    Ticket_Type_Code.PbmProactiveDrugSearch
], CLIENT_PORTAL_TYPES, true);
